var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.99984 12.8334C3.77984 12.8334 1.1665 10.2259 1.1665 7.00008C1.1665 3.78008 3.77984 1.16675 6.99984 1.16675C10.2257 1.16675 12.8332 3.78008 12.8332 7.00008C12.8332 10.2259 10.2257 12.8334 6.99984 12.8334ZM8.86067 9.16425C8.93067 9.20508 9.0065 9.22841 9.08817 9.22841C9.234 9.22841 9.37984 9.15258 9.4615 9.01258C9.584 8.80841 9.51984 8.54008 9.30984 8.41175L7.23317 7.17508V4.48008C7.23317 4.23508 7.03484 4.04258 6.79567 4.04258C6.5565 4.04258 6.35817 4.23508 6.35817 4.48008V7.42591C6.35817 7.57758 6.43984 7.71758 6.574 7.79925L8.86067 9.16425Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.2f415ac71f462c4ac9e2416e3ff068ad.svg";
export { ForwardRef as ReactComponent };